import { PRACTICE, SITE_URL, DEFAULT_OG_IMAGE } from './site';

export const localBusinessSchema = {
  '@context': 'https://schema.org',
  '@type': ['Psychologist', 'LocalBusiness'],
  name: PRACTICE.name,
  url: SITE_URL,
  image: DEFAULT_OG_IMAGE,
  email: PRACTICE.email,
  telephone: PRACTICE.telephone,
  priceRange: '€€',
  address: {
    '@type': 'PostalAddress',
    streetAddress: PRACTICE.streetAddress,
    addressLocality: PRACTICE.addressLocality,
    postalCode: PRACTICE.postalCode,
    addressCountry: PRACTICE.addressCountry,
  },
  areaServed: {
    '@type': 'City',
    name: 'Ljubljana',
  },
  knowsAbout: [
    'psihoterapija',
    'sistemska psihoterapija',
    'psihološko svetovanje',
    'psihoterapija za otroke',
    'psihoterapija za mladostnike',
    'partnerska terapija',
    'družinska terapija',
    'medicinska hipnoza',
  ],
  founder: {
    '@type': 'Person',
    name: PRACTICE.personName,
    jobTitle: PRACTICE.jobTitle,
    sameAs: PRACTICE.sameAs,
  },
};

export const personSchema = {
  '@context': 'https://schema.org',
  '@type': 'Person',
  name: PRACTICE.personName,
  jobTitle: PRACTICE.jobTitle,
  url: SITE_URL,
  image: DEFAULT_OG_IMAGE,
  email: PRACTICE.email,
  telephone: PRACTICE.telephone,
  address: {
    '@type': 'PostalAddress',
    streetAddress: PRACTICE.streetAddress,
    addressLocality: PRACTICE.addressLocality,
    postalCode: PRACTICE.postalCode,
    addressCountry: PRACTICE.addressCountry,
  },
  knowsAbout: localBusinessSchema.knowsAbout,
  sameAs: PRACTICE.sameAs,
};

